// Classes.
import { BaseComponentLocator } from "../locators/base.component-locator";
import { StringLocatorComponent } from "./../locators/string.locator-component";
import { DisciplineLocatorComponent } from "./../locators/discipline.locator-component";
import { CategoryLocatorComponent } from "./../locators/category.locator-component";
import { CardinalityLocatorComponent } from "./../locators/cardinality.locator-component";
import { DateLocatorComponent } from "./../locators/date.locator-component";
import { AthleteLocatorComponent } from "./../locators/athlete.locator-component";
import { LevelLocatorComponent } from "./../locators/level.locator-component";
import { WithResultsLocatorComponent } from "./../locators/with-results.locator-component";
import { LiveLocatorComponent } from "./../locators/live.locator-component";
import { NewsPopularLocatorComponent } from "./../locators/news-popular.locator-component";
import { SortingLocatorComponent } from "./../locators/sorting.locator-component";
import { DetailedLocatorComponent } from "./../locators/detailed.locator-component";
import { ParaArcheryLocatorComponent } from "./paraarchery.locator-component";
import { RankSortingLocatorComponent } from "./indoor-sorting-locator";
import { CategoryIdLocatorComponent } from "./categoryid.locator-component";

// Interface.
import { LocatorInterface, LocatorType } from "../interfaces/locator.interface";
import { BooleanLocatorComponent } from "./boolean.locator-component";
import { DivisionCategoryListLocator } from "./division.locator";

export type LocatorComponentTypes =
  | "discipline"
  | "category"
  | "team"
  | "year"
  | "date"
  | "athlete"
  | "level"
  | "results"
  | "popular"
  | "live"
  | "search"
  | "sort"
  | "detailed"
  | "catid"
  | "catcode"
  | "series"
  | "isPara"
  | "recordsAreas"
  | "sortrank"
  | "worldrecordstatus"
  | "worldrankingevent"
  | "embedfiles"
  | "event"
  | "country"
  | "sortindoor";

const types: Map<string, () => BaseComponentLocator> = new Map();

types.set("discipline", () => new DisciplineLocatorComponent());
types.set("category", () => new CategoryLocatorComponent());
types.set("team", () => new CardinalityLocatorComponent());
types.set("year", () => new StringLocatorComponent());
types.set("date", () => new DateLocatorComponent());
types.set("athlete", () => new AthleteLocatorComponent());
types.set("level", () => new LevelLocatorComponent());
types.set("results", () => new WithResultsLocatorComponent());
types.set("live", () => new LiveLocatorComponent());
types.set("popular", () => new NewsPopularLocatorComponent());
types.set("search", () => new StringLocatorComponent());
types.set("sort", () => new SortingLocatorComponent());
types.set("detailed", () => new DetailedLocatorComponent());
types.set("catid", () => new CategoryIdLocatorComponent());
types.set("catcode", () => new StringLocatorComponent());
types.set("sortindoor", () => new RankSortingLocatorComponent());
types.set("sortrank", () => new RankSortingLocatorComponent());
types.set("isPara", () => new ParaArcheryLocatorComponent());
types.set('worldrecordstatus', () => new CategoryIdLocatorComponent());
types.set('worldrankingevent', () => new CategoryIdLocatorComponent());
types.set('embedfiles', () => new DetailedLocatorComponent());
types.set('event', () => new StringLocatorComponent());
types.set('country', () => new StringLocatorComponent());
/**
 * Base class for data locators.
 *
 */
export class BaseLocator implements LocatorInterface {
  getComponents(): BaseComponentLocator[] {
    return this.locatorComponents;
  }
  protected locatorComponents: BaseComponentLocator[] = [];
  public nameInside = '';
  public type: StringLocatorComponent;

  constructor(locatorType: LocatorType) {
    // All locator have type, add it.
    this.type = new StringLocatorComponent(locatorType);
    this.pushComponent(this.type);
  }

  public addComponentByType(type: LocatorComponentTypes, name: string = type, nameParam?: string, nameInsideLocator?: string) {
    this.nameInside = nameInsideLocator;
    const componentInstance: BaseComponentLocator = types.get(type)();
    this[name] = componentInstance;
    componentInstance.assignable_param = nameParam;
    this.pushComponent(componentInstance);
  }

  public getComponent(name: string) {
    return this[name];
  }

  public pushComponent(component: BaseComponentLocator) {
    this.locatorComponents.push(component);
  }

  public getId(): string {
    const idComponents = this.locatorComponents.map(component =>
      component.toString()
    );
    return idComponents.join("_");
  }

  public getType(): LocatorType {
    return <LocatorType>this.type.toString();
  }

}
